var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseRadarChart',{attrs:{"options":_vm.chartOptions,"labels":_vm.labels,"datasets":_vm.datasets,"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }